import React from 'react';
import PropTypes from 'prop-types';
import { PaginationListStandalone, PaginationTotalStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';

import styles from './pagination.module.css';

const Pagination = ({ total, paginationProps, className = '', rowsHidden }) => (
	<>
		{!rowsHidden && <PaginationListStandalone {...paginationProps} />}
		<div className={`${className ? className : styles.pagination}`}>
			{!rowsHidden && <SizePerPageDropdownStandalone {...paginationProps} />}
			<PaginationTotalStandalone dataSize={total} {...paginationProps} />
		</div>
	</>
);

Pagination.propTypes = {
	total: PropTypes.number.isRequired,
	paginationProps: PropTypes.object.isRequired,
	className: PropTypes.string,
	rowsHidden: PropTypes.bool
};

export default Pagination;
